// extracted by mini-css-extract-plugin
export default {"flex":"md_flex__iAhKd","detail":"md_detail__GVN21"};